import fetch from 'isomorphic-fetch';
import { ApolloClient, InMemoryCache } from '@apollo/client';
import { relayStylePagination } from '@apollo/client/utilities';

const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        posts: relayStylePagination(), //To merge the updated query with the previous one (fetchmore)
      }
    }
  }
})

export const client = new ApolloClient({
  uri: `${process.env.WPGRAPHQL_URL}`, //THIS IS THE URL OF THR GRAPHQL WE WANTO TO QUERY
  cache: cache,
  /* fetch: fetch, */
});